import { produce } from 'immer';

import { getPartnumber } from '@/utils/millesimaUtils';

export const getDiffProducts = (newList = [], oldList = []) => {
  const getPartnumberWithCusto = (product) => {
    const partNumber = getPartnumber(product);
    return product.custoText ? partNumber + product.custoText : partNumber;
  };

  const diffList = newList.map((p) => {
    const partnumber = getPartnumberWithCusto(p);
    const old = oldList.find((oldProd) => getPartnumberWithCusto(oldProd) === partnumber);

    return !old || old.quantity !== p.quantity ? produce(p, (draft) => {
      draft.diffPartnumber = partnumber;
      draft.diffQty = p.quantity - (old ? old.quantity : 0);
      draft.diffName = p.wineBox ? 'winebox.winebox' : p.product.productName;
    }) : undefined;
  }).filter((x) => !!x);

  oldList.forEach((oldItem) => {
    const partnumber = getPartnumberWithCusto(oldItem);
    const alreadyIn = newList.some((prod) => getPartnumberWithCusto(prod) === partnumber);

    if (!alreadyIn) {
      diffList.push(produce(oldItem, (draft) => {
        draft.diffPartnumber = partnumber;
        draft.diffQty = -oldItem.quantity;
        draft.diffName = oldItem.wineBox ? 'winebox.winebox' : oldItem.product.productName;
      }));
    }
  });

  return diffList;
};

export const restoreInitialState = (draft, initialState): void => {
  draft.content = initialState.content;
  draft.status = initialState.status;
  draft.last = initialState.last;
  draft.diff = initialState.diff;
};

export const buildReducerError = (error: any): { error: any } => {
  return { error: error && error.error ? error.error : error };
};
